import { Pipe, PipeTransform } from '@angular/core';
import { RecordField } from '../models/record/recordfield.class';

@Pipe({
    name: 'FieldsGroup',
    standalone: false,
})
export class FieldsGroupPipe implements PipeTransform {
    transform(fields: RecordField[], group: string): RecordField[] {
        let filteredFields = fields;
        filteredFields =
            fields?.filter(field => {
                return (field.fieldSection === group || (!field.fieldSection && !group)) && field.show !== false;
            }) || [];
        return filteredFields;
    }
}
